module.exports = __webpack_public_path__ + "media/images/fpp-banner-2-1bb33f18473317c65bfe32fa7bc5f486.png";